import $ from 'jquery';

const Search = (el) => {
    const width = $('.header__search--desktop').outerWidth(true);
    $('.header__search-controls').css({'min-width': width})

    $(el).on('focus', () => {
        $(el).parent().addClass('search-form--active');
        $('.header__search--desktop').fadeOut();
        $('.header__search-blur').css('display', 'flex').hide().fadeIn();
    });

    $('.js-close-search').on('click', () => {
        $(el).parent().removeClass('search-form--active');
        $('.header__search--desktop').fadeIn();
        $('.header__search-blur').fadeOut();
    });
};

export default Search;
